import { render, staticRenderFns } from "./DownloadInvoice.vue?vue&type=template&id=5b9c791c&scoped=true"
import script from "./DownloadInvoice.vue?vue&type=script&lang=js"
export * from "./DownloadInvoice.vue?vue&type=script&lang=js"
import style0 from "./DownloadInvoice.vue?vue&type=style&index=0&id=5b9c791c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9c791c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
